import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../shared/components';
import MiciContext from '../MiciCaseContext';
import MiciCaseForm, { otherReasonId } from './MiciCausesForm';
import Context from '../../../App/MainProvider/context';
import Role from '../../../../types/role';

const MiciCauses: React.FC = () => {
  const { t } = useTranslation();
  const { inSuperUserMode, user } = useContext(Context);
  const {
    data: { miciCase, miciCauses },
  } = useContext(MiciContext);
  const [changeCausesVisible, setChangeCausesVisible] = useState(false);
  const canSave =
    miciCase.operation.isMember ||
    user.roleCode === Role.HSO ||
    (user.roleCode === Role.GroupHead &&
      miciCase.operation.primaryMember &&
      miciCase.operation.primaryMember.groupCode === user.groupCode) ||
    inSuperUserMode();
  return (
    <>
      <h5>
        {`${t('causes')} `}
        <Button
          className="btn-tertiary no-padding"
          icon="external-link-alt"
          text=""
          disabled={!canSave}
          onClick={() => setChangeCausesVisible(true)}
        />
      </h5>
      <p className="mb-5">
        {miciCase.miciCauses
          .map((c) => ({
            cause: miciCauses.find((x) => c.miciCauseId === x.id && x.language === 'en'),
            otherReason: c.otherReason,
          }))
          .sort((x, y) => (x.cause && y.cause ? x.cause.order - y.cause.order : 0))
          .map((c, i) => {
            if (!c.cause) {
              return null;
            }
            if (c.cause.id === Number(otherReasonId)) {
              return <span>Other: {c.otherReason}</span>;
            }
            return (
              <>
                <span>{c.cause.description}</span>
                {i < miciCase.miciCauses.length - 1 && <span className="ml-4 mr-4">|</span>}
              </>
            );
          })}
      </p>
      <MiciCaseForm visible={changeCausesVisible} setVisible={setChangeCausesVisible} />
    </>
  );
};

export default MiciCauses;
